/**
 * # Traveller Input Page Hooks
 *
 *
 */
import { useCurrentProduct } from 'hooks';
import { useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useBackLinkProps } from 'modules/eurail/pages/TravellerInputPage/hooks/useBackLinkProps';
import { getEurailTravellerInputPageQueryParams } from 'modules/eurail/utils/query-params';

import useProductSummaryProps from './useProductSummaryProps';
import useReservationInformationFormProps from './useReservationInformationFormProps';
import useTracking from './useTracking';

/**
 * Retrieve data for the traveller input page.
 */
export const useTravellerInputPage = () => {
  const location = useLocation();

  const travellerInputPageQueryParams = useMemo(() => {
    return getEurailTravellerInputPageQueryParams(location);
  }, [location]);

  const { currentProduct } = useCurrentProduct(travellerInputPageQueryParams.searchResultID);

  const reservationFormRef = useRef<HTMLFormElement>(null);
  const [isReservationUpdateLoading, setIsReservationUpdateLoading] = useState(false);

  const isPageReady = Boolean(currentProduct);

  useTracking(isPageReady);

  const travellerInformationFormProps = useReservationInformationFormProps(
    currentProduct,
    reservationFormRef,
    setIsReservationUpdateLoading,
  );

  const productSummaryProps = useProductSummaryProps(
    currentProduct,
    reservationFormRef,
    isReservationUpdateLoading,
  );

  const backLinkProps = useBackLinkProps(currentProduct);

  return {
    isPageReady,
    travellerInformationFormProps,
    productSummaryProps,
    backLinkProps,
  };
};
